import { ArcGISLayerDefinition } from '../models/arcgis-types';

const ARCGIS_WEB_PIXELS_PER_METER = 39.37 * 96;

function scaleToResolution(scale: number | undefined): number {
    return scale !== undefined && Number.isFinite(scale) && scale > 0 ? scale / ARCGIS_WEB_PIXELS_PER_METER : 0;
}

export function getArcGISResolutionRange(
    definition: Pick<ArcGISLayerDefinition, 'minScale' | 'maxScale'>,
): { minResolution: number; maxResolution: number } {
    const maxResolution = scaleToResolution(definition.minScale);
    return {
        minResolution: scaleToResolution(definition.maxScale),
        // ArcGIS includes minScale; OpenLayers excludes maxResolution.
        maxResolution: maxResolution ? maxResolution * (1 + Number.EPSILON) : Infinity
    };
}
